/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Carrier = z.string();

export type Carrier = z.infer<typeof Carrier>;
